import { useAuthenticatedAxiosInstance } from './useAuthenticatedAxiosInstance';
import { useCallback } from 'react';
import { AxiosResponse } from 'axios';
import { getEnvironmentConfig } from '../environmentConfig';

export interface ApiResource {
    id: string;
    nodeInstanceId: number;
    name: string;
    endpoints: unknown;
    createdAt: string;
    updatedAt: string;
}

export const useApiServerApi = () => {
    const api = useAuthenticatedAxiosInstance(`${getEnvironmentConfig().graphServiceUrl}`);

    const getApisForGraph = useCallback(
        async (graphId: string): Promise<ApiResource[]> => {
            const result: AxiosResponse = await api.get(`/apis/graph/${graphId}`);
            return result.data.apis;
        },
        [api],
    );

    const createApi = useCallback(
        async (graphId: string, nodeInstanceId: number, name: string): Promise<ApiResource> => {
            const result: AxiosResponse = await api.post(`/apis`, { graphId, nodeInstanceId, name });
            return result.data.api;
        },
        [api],
    );

    const updateApi = useCallback(
        async (
            apiId: string,
            updates: {
                name?: string;
                endpoints?: unknown;
                expectedHeaders?: string[];
                authConfig?: {
                    enabled: boolean;
                    method: string;
                    headerName?: string;
                } | null;
            },
        ): Promise<ApiResource> => {
            const result: AxiosResponse = await api.put(`/apis/${apiId}`, updates);
            return result.data.api;
        },
        [api],
    );

    const deleteApi = useCallback(
        async (apiId: string): Promise<void> => {
            await api.delete(`/apis/${apiId}`);
        },
        [api],
    );

    return {
        getApisForGraph,
        createApi,
        updateApi,
        deleteApi,
    };
};
